export class ActivityModel {
  id: number;
  uid: string;
  name: string;
  preinvoiceNumber: string;
  invoiceNumber: string;
  deliveryNoteNumber: string;
  certificateNumber: string;
  recurrentNumber: string;
  ticketNumber: string;
  ticketAccountEntrance: string;
  ticketAccountExpense: string;
  iaeId: number;
  seasonalActivity: boolean;
  seasonalActivityNumberDays: number;
  total: number; // ONLY FOR SHOW AT TABLE VIEW WEB
  percentage: number; // ONLY FOR SHOW AT TABLE VIEW WEB
  population: number;
  modulesIndicesBaseIngresoId: number;
  commercialName: string;
  useCommercialNameInvoice: boolean;

  //Datos de salida referente a ActivitiesTaxConfig
  igiCexenta: boolean;
  igiCnoSujeta: boolean;
  igic: boolean;
  ivAexenta: boolean;
  ivAnoSujeta: boolean;
  iva: boolean;
  prorrataEspecial: boolean;
  prorrataGeneral: boolean;
  reagp: boolean;
  reagpCompensacion: boolean;
  reav: boolean;
  rebu: boolean;
  recc: boolean;
  reoa: boolean;
  repep: boolean;
  recm: boolean;
  oteal: boolean;
  isProject: boolean;
  widthLogoPdf: number;
  heightLogoPdf: number;
  widthLogoTicket: number;
  heightLogoTicket: number;
  invoiceSeriesNumber: number;
  invoiceLayout: number;
  invoiceAccentColor: string;
  invoiceSidebarText: string;

  constructor() {
    this.preinvoiceNumber = "PRE-00001";
    this.invoiceNumber = "FRA-00001";
    this.deliveryNoteNumber = "ALB-00001";
    this.certificateNumber = "CERT-00001";
    this.recurrentNumber = "RE-00001";
    this.ticketNumber = "TICKET-00001";
    this.id = 0;
    this.uid = "00000000-0000-0000-0000-000000000000";
    this.name = "Nueva Actividad";
    this.ticketAccountExpense = '';
    this.ticketAccountEntrance = '';
    this.total = 0;
    this.percentage = 0;
    this.invoiceLayout = InvoiceLayout.ClassicInvoiceLayout;
  }
}


export class ActivitiesIaeModel {
  id: number;
  epigrafe: string;
  codigoActividad: string;
  descripcion: string;
}

export class ActivitiesModulesModel {
  epigrafe: string;
  definicion: string;
  activityId: number;
  moduleId: number;
  units: number;
  regimen: number;
}

export class ActivitiesModulesIndicesBaseIngreso {
  id: number;
  descripcion: string;
  indiceCuotaIVA: number;
  indiceCuotaIGIC: number;
  ingresoIVA: number;
  ingresoIGIC: number;
}

//Datos de Carga referente a ActivitiesTaxConfig
export class ActivitiesTaxConfigModel {
  uid: boolean;
  igiCexenta: boolean;
  igiCnoSujeta: boolean;
  igic: boolean;
  ivAexenta: boolean;
  ivAnoSujeta: boolean;
  iva: boolean;
  prorrataEspecial: boolean;
  prorrataGeneral: boolean;
  reagp: boolean;
  reagpCompensacion: boolean;
  reav: boolean;
  rebu: boolean;
  recc: boolean;
  reoa: boolean;
  repep: boolean;
  recm: boolean;
  oteal: boolean;
}

export class ActivityImageModel{
  uid:string;
  alias:string;
  fileId: number;
  isDeleted: boolean;
  createAt:Date;
  activityId: number;
  width?: number;
  height?: number;
}

export enum InvoiceLayout {
  ClassicInvoiceLayout = 1,
  CorporateInvoiceLayout = 2,
  ElegantInvoiceLayout = 3,
  ModernInvoiceLayout = 4
}
